<template>
    <van-popup
        v-model="visibleDialog"
        position="bottom"
        closeable
        close-icon="close"
        @close='onClose'
        :closeOnClickModal='false'
        :round="true"
    >
        <div class="conpon">
            <div class="head f32 col333 textCenter">优惠券</div>
            <div class="conponList">
                <div class="items" v-for="(item,index) in couponsList" :key="index">
                    <div class="itemLeft f64">
                        <span class="f36">¥</span>{{item.couponValue}}
                    </div>
                    <div class="itemRight" :class="[item.hasDrawed?'effectImg':'',item.canDraw?'':'effectImg2']">
                        <div class="title">
                            <h3 class="f28">{{item.couponName}}</h3>
                            <p class="col666"><span>{{item.effectiveStartDate|formatDate3}}-{{item.effectiveEndDate|formatDate3}}</span></p>
                            <p class="col666" v-if="item.couponType===1"><span>满{{item.reachAmount}}元使用</span></p>
                            <p class="col666" v-if="item.couponType===2"><span>无门槛</span></p>
                            <p class="col666">
                                <!--<span>指定类目参加</span>-->
                                <span v-if="item.joinType === 1">全场参加</span>
                                <span v-if="item.joinType === 2">指定类目</span>
                                <span v-if="item.joinType === 3">指定商品</span>
                            </p>
                        </div>
                        <div class="progree" v-if="item.canDraw">
                            <mt-progress :value="item.drawedRatio" :bar-height="4">
                                <div class="f24 col666 pro" slot="end">已领{{item.drawedRatio}}%</div>
                            </mt-progress>
                        </div>
                        <div class="btn" v-if="item.canDraw" @click.stop="onDraw(item)">立即领取</div>
                        <div class="btn btn2" v-if="!item.canDraw">立即领取</div>
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        couponsList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible')
        },
        onDraw (item) {
            this.$emit('onDraw', item)
        }
    }
}
</script>

<style lang="scss" scoped>
    .conpon {
        background: #ffffff;
        .head {
            position: relative;
            height: 108px;
            line-height: 108px;
            padding: 0 24px;
        }
        .conponList {
            text-align: left;
            background: #f5f5f5;
            height: 800px;
            overflow-y: auto;
            .items {
                background: #ffffff;
                border-radius: 12px;
                margin-top: 20px;
                margin-left: 24px;
                margin-right: 24px;
                height: 224px;
                display: flex;
                justify-content: flex-start;
                h3 {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    white-space: normal;
                    word-break: break-all;
                }
                .itemLeft {
                    width: 224px;
                    line-height: 224px;
                    text-align: center;
                    background: url('../../../../../assets/img/b2b/coupon.png')
                        no-repeat;
                    background-size: 100% 100%;
                    font-family: SFUIDisplay-Bold;
                    font-weight: bold;
                    color: rgba(255, 255, 255, 1);
                    &.couponCopy {
                        background: url('../../../../../assets/img/b2b/couponCopy.png')
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .itemRight {
                    flex: 1;
                    padding: 32px 28px 0;
                    position: relative;
                    .title {
                        p {
                            margin-top: 6px;
                            font-size: 22px;
                        }
                    }
                    .time {
                        font-size: 22px;
                        margin-top: 26px;
                        white-space: nowrap;
                        transform: scale(0.95);
                        transform-origin: 0 0 0;
                    }
                    .progree {
                        width: 246px;
                        .pro {
                            margin-left: 14px;
                            transform: scale(0.95);
                            height: 0px;
                        }
                    }
                    .btn {
                        width: 144px;
                        height: 48px;
                        line-height: 48px;
                        text-align: center;
                        color: #ffffff;
                        border-radius: 48px;
                        font-size: 22px;
                        background: #ff834e;
                        position: absolute;
                        right: 16px;
                        bottom: 16px;
                    }
                    .btn2 {
                        background: #f5f5f5;
                        color: #c7c7c7;
                    }
                    &.effectImg {
                        background: url('../../../../../assets/img/b2b/img_user1.png')
                            no-repeat;
                        background-size: 112px 96px;
                        background-position: 366px 0;
                    }
                    &.effectImg2 {
                        background: url('../../../../../assets/img/b2b/img_user2.png')
                            no-repeat;
                        background-size: 112px 96px;
                        background-position: 366px 0;
                    }
                }
            }
        }
    }
    /deep/ .van-popup__close-icon {
        font-size: 44px;
    }
    /deep/ .van-popup__close-icon--top-right {
        top: 30px;
        right: 30px;
    }
</style>